const runtimeExternalUrls =
  typeof window !== "undefined" &&
  window.VECTOR_EXTERNAL_URLS &&
  typeof window.VECTOR_EXTERNAL_URLS === "object"
    ? window.VECTOR_EXTERNAL_URLS
    : {};

function resolveExternalUrl(key, fallback = "") {
  const value = runtimeExternalUrls[key];
  return typeof value === "string" && value.trim() !== ""
    ? value.trim()
    : fallback;
}

export const EXT_OMNI_GEOC_URL = resolveExternalUrl("EXT_OMNI_GEOC_URL");

export const EXT_OMNI_ROUTE_URL = resolveExternalUrl("EXT_OMNI_ROUTE_URL");

export const EXT_OMNI_SMSATT_URL = resolveExternalUrl("EXT_OMNI_SMSATT_URL");

export const EXT_OMNI_GPT_GATEWAY_URL = resolveExternalUrl(
  "EXT_OMNI_GPT_GATEWAY_URL"
);

export const EXT_OMNI_ALERT_CREATOR_URL = resolveExternalUrl(
  "EXT_OMNI_ALERT_CREATOR_URL"
);

export const EXT_OMNI_FLEET_SAFETY_URL = resolveExternalUrl(
  "EXT_OMNI_FLEET_SAFETY_URL"
);

export const EXT_OMNI_TRIP_REPORT_CREATOR_PROD_URL = resolveExternalUrl(
  "EXT_OMNI_TRIP_REPORT_CREATOR_PROD_URL"
);

export const EXT_OMNI_TRIP_REPORT_CREATOR_URL = resolveExternalUrl(
  "EXT_OMNI_TRIP_REPORT_CREATOR_URL"
);

export const EXT_OMNI_UNIT_PERFORMANCE_URL = resolveExternalUrl(
  "EXT_OMNI_UNIT_PERFORMANCE_URL"
);

export async function fetchJson(url, options) {
  const response = await fetch(url, options);

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function fetchJsonSafe(
  url,
  { fallback = null, logLabel = "external fetch", options } = {}
) {
  try {
    return await fetchJson(url, options);
  } catch (error) {
    console.warn(`${logLabel} failed`, url, error);
    return fallback;
  }
}
